const XLSX = require('xlsx');

/**
 * Export data to Excel with optional header rows.
 * @param {Array<Object>} data - Row data as array of objects
 * @param {string} filename - Output filename
 * @param {Object} [options]
 * @param {Array<Array<string>>} [options.headerRows] - Metadata rows prepended above data (e.g. [['Report:', 'Audit Trail'], ['Store:', 'Main']])
 */
export const exportToExcel = (data, filename, options = {}) => {
  const { headerRows } = options;

  if (headerRows && headerRows.length > 0) {
    // Build worksheet from header rows + blank separator + data
    const ws = XLSX.utils.aoa_to_sheet(headerRows);
    // Leave a blank row between headers and data
    const startRow = headerRows.length + 1;
    XLSX.utils.sheet_add_json(ws, data, { origin: startRow });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename);
  } else {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename);
  }
};
